import { EXTERNAL_MENTION_ENTITY_TYPE } from './types';
import MentionComponent from './mentionComponent';
export const typeMapper = ()=>({
        [EXTERNAL_MENTION_ENTITY_TYPE]: {
            component: MentionComponent,
            elementType: 'inline'
        }
    });
